
























import { Prop, Component, Vue } from 'vue-property-decorator'
import { Designer } from '../../types/designers'

@Component
export default class DesignerCard extends Vue {
  @Prop({ default: {} })
  designer!: Designer
}
